// 会話の詳細データを保存する処理
import { apiEndPoint } from "./endPoint";

interface messageData {
  content: string;
  role: string;
}

export const putConversationData = async (
  conversationId: string,
  messages: messageData[],
  token: string
) => {
  const url = `${apiEndPoint}/putConversationData`;

  const putData = {
    conversationId: conversationId,
    messages: messages,
  };
  console.log(putData);

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(putData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
